import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Reference } from '../../../_entity/reference/ModuleFE_Reference.js';
import { Renderer_ReferenceHeader } from './renderers/Renderer_ReferenceHeader/Renderer_ReferenceHeader.js';
import { Editor_Reference } from '../../_editors/reference/Editor_Reference.js';
import { WorkHubItem_Reference } from '../../../search/items/reference.js';
import { resolveReferenceDisplay } from '../../../_entity.js';
import { md5 } from '@nu-art/ts-common';
import './Manager_WorkHub_Reference.scss';
export class Manager_WorkHub_Reference extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.tabId = nextProps.tabId;
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.readonly)
            state.renderArgs = { ...state.renderArgs, editMode: false };
        const isNewItem = nextProps.renderArgs.itemId.startsWith('###NEWITEM###');
        const reference = isNewItem ? {} : ModuleFE_Reference.cache.unique(nextProps.renderArgs.itemId) ?? {};
        if (!state.editable || state.editable.item._id !== reference._id) {
            state.editable = new EditableDBItemV3(reference, ModuleFE_Reference)
                .setOnChanged(async () => this.forceUpdate())
                .setAutoSave(true)
                .setOnSaveCompleted((savedItem) => {
                if (isNewItem && savedItem._id) {
                    const newTabId = md5(`${ModuleFE_Reference.dbDef.dbKey}-${savedItem._id}`);
                    WorkHubItem_Reference.openTab(newTabId, resolveReferenceDisplay(savedItem) || 'Reference', {
                        itemId: savedItem._id,
                        editMode: !state.renderArgs.readonly,
                        readonly: state.renderArgs.readonly,
                    });
                    WorkHubItem_Reference.closeTab(state.tabId);
                }
            });
        }
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'manager-workhub-reference', children: [_jsx(Renderer_ReferenceHeader, { workHubItem: this.props.workHubItem, renderArgs: this.state.renderArgs }), _jsx(Editor_Reference, { reference: this.state.editable, editMode: this.state.renderArgs.editMode })] });
    }
}
//# sourceMappingURL=Manager_WorkHub_Reference.js.map